export const PreChatActionTypes = {
  SET_DIAGNOSTIC_LOADING: 'SET_DIAGNOSTIC_LOADING',
  SET_PRODUCTS_BY_STATUS_LOADING: 'SET_PRODUCTS_BY_STATUS_LOADING',

  GET_DIAGNOSTIC_REQUEST: 'GET_DIAGNOSTIC_REQUEST',
  GET_DIAGNOSTIC_SUCCESS: 'GET_DIAGNOSTIC_SUCCESS',
  GET_DIAGNOSTIC_FAILURE: 'GET_DIAGNOSTIC_FAILURE',
  SET_DIAGNOSTIC: 'SET_DIAGNOSTIC',
  RELOAD_DIAGNOSTIC: 'RELOAD_DIAGNOSTIC',
  SET_INVOICE_ID: 'SET_INVOICE_ID',
  SET_HOLD_REDIRECT: 'SET_HOLD_REDIRECT',
  SET_SCREEN_TO_SHOW_IN_PRECHAT: 'SET_SCREEN_TO_SHOW_IN_PRECHAT',
  BILLING_GENERATED: 'BILLING_GENERATED',
  REACTIVATION_REDIRECT: 'REACTIVATION_REDIRECT',
  SET_TRUST_REACTIVATION_INVOICE_ID: 'SET_TRUST_REACTIVATION_INVOICE_ID',
  SET_INVOICE_TICKET_WILL_OPEN: 'SET_INVOICE_TICKET_WILL_OPEN',
  SET_SUBSCRIPTION_TO_CANCEL: 'SET_SUBSCRIPTION_TO_CANCEL',
  SET_SUBSCRIPTION_TO_CHANGE_PAYMENT_METHOD: 'SET_SUBSCRIPTION_TO_CHANGE_PAYMENT_METHOD',
  SET_SUBSCRIPTION_REDIRECT_FROM_PRECHAT: 'SET_SUBSCRIPTION_REDIRECT_FROM_PRECHAT',
  PRODUCT_BY_STATUS_REQUEST: 'PRODUCT_BY_STATUS_REQUEST',
  PRODUCT_BY_STATUS_SUCCESS: 'PRODUCT_BY_STATUS_SUCCESS',
  PRODUCT_BY_STATUS_FAILURE: 'PRODUCT_BY_STATUS_FAILURE',
  SET_PRODUCT_BY_STATUS: 'SET_PRODUCT_BY_STATUS',
  SET_TOS_REDIRECT: 'SET_TOS_REDIRECT',
  SET_VPS_REDIRECT: 'SET_VPN_REDIRECT',
  SET_VPS_PRODUCT_ID: 'SET_VPS_PRODUCT_ID',
  SET_VPS_TERMS_ACCEPTED: 'SET_VPS_TERMS_ACCEPTED',
  GET_PRODUCT_DETAILS_REQUEST: 'GET_PRODUCT_DETAILS_REQUEST',
  GET_PRODUCT_DETAILS_SUCCESS: 'GET_PRODUCT_DETAILS_SUCCESS',
  GET_PRODUCT_DETAILS_FAILURE: 'GET_PRODUCT_DETAILS_FAILURE',
  SET_PRODUCT_DETAILS_LOADING: 'SET_PRODUCT_DETAILS_LOADING',
  SET_PRODUCT_DETAILS: 'SET_PRODUCT_DETAILS',
  SET_EPP_KEY_FLOW: 'SET_EPP_KEY_FLOW',
  SET_RESERVED_DOMAIN_FLOW: 'SET_RESERVED_DOMAIN_FLOW',
  GET_WEEK_DAY_REQUEST: 'GET_WEEK_DAY_REQUEST',
  SET_WEEK_DAY: 'SET_WEEK_DAY',
  GET_WEEK_DAY_SUCCESS: 'GET_WEEK_DAY_SUCCESS',
  GET_WEEK_DAY_FAILURE: 'GET_WEEK_DAY_FAILURE',
  HANDLE_CHAT_DISPLAY: 'HANDLE_CHAT_DISPLAY',
  SET_SHOW_PRE_CHAT: 'SET_SHOW_PRE_CHAT',
  SET_ACTIVE_CHAT: 'SET_ACTIVE_CHAT',
  SET_TICKET_TYPE: 'SET_TICKET_TYPE',
  START_CHATBOT_REQUEST: 'START_CHATBOT_REQUEST',
  START_CHATBOT_SUCCESS: 'START_CHATBOT_SUCCESS',
  START_CHATBOT_FAILURE: 'START_CHATBOT_FAILURE',
  SET_CHATBOT_SESSION_ID: 'SET_CHATBOT_SESSION_ID',
  SEND_CHATBOT_MESSAGE_REQUEST: 'SEND_CHATBOT_MESSAGE_REQUEST',
  SEND_CHATBOT_MESSAGE_SUCCESS: 'SEND_CHATBOT_MESSAGE_SUCCESS',
  SEND_CHATBOT_MESSAGE_FAILURE: 'SEND_CHATBOT_MESSAGE_FAILURE',
  SET_CHATBOT_MESSAGE: 'SET_CHATBOT_MESSAGE',
  EVALUATE_CHATBOT_ANSWER_REQUEST: 'EVALUATE_CHATBOT_ANSWER_REQUEST',
  EVALUATE_CHATBOT_ANSWER_SUCCESS: 'EVALUATE_CHATBOT_ANSWER_SUCCESS',
  EVALUATE_CHATBOT_ANSWER_FAILURE: 'EVALUATE_CHATBOT_ANSWER_FAILURE',

  START_CHAT_SESSION_REQUEST: 'START_CHAT_SESSION_REQUEST',
  START_CHAT_SESSION_SUCCESS: 'START_CHAT_SESSION_SUCCESS',
  START_CHAT_SESSION_FAILURE: 'START_CHAT_SESSION_FAILURE',

  FINISH_CHAT_SESSION_REQUEST: 'FINISH_CHAT_SESSION_REQUEST',
  FINISH_CHAT_SESSION_SUCCESS: 'FINISH_CHAT_SESSION_SUCCESS',
  FINISH_CHAT_SESSION_FAILURE: 'FINISH_CHAT_SESSION_FAILURE',

  CHAT_STATUS_REQUEST: 'CHAT_STATUS_REQUEST',
  CHAT_STATUS_SUCCESS: 'CHAT_STATUS_SUCCESS',
  CHAT_STATUS_FAILURE: 'CHAT_STATUS_FAILURE',

  N8N_FORCE_OPEN_SUPPORT: 'N8N_FORCE_OPEN_SUPPORT',

  GET_ZENDESK_TOKEN_REQUEST: 'GET_ZENDESK_TOKEN_REQUEST',
  GET_ZENDESK_TOKEN_SUCCESS: 'GET_ZENDESK_TOKEN_SUCCESS',
  GET_ZENDESK_TOKEN_FAILURE: 'GET_ZENDESK_TOKEN_FAILURE',
  CLEAR_ZENDESK_TOKEN: 'CLEAR_ZENDESK_TOKEN',
};
